import { Directive, HostListener, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

import { CnpjValidator } from '../validators/cnpj.validator';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[cnpjMask]',
  standalone: false,
  providers: [{
    provide: NG_VALIDATORS, useExisting: CnpjDirective, multi: true
  }]
})
export class CnpjDirective implements Validator {
  onTouched: any;
  onChange: any;
  value: '' | undefined;
  cnpjType = '99.999.999/9999-99';

  @Input('cnpjMask') cnpjMask: string | undefined;

  constructor() { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return CnpjValidator.validate(control);
  }

  @HostListener('input', ['$event'])
  onInput($event: any) {
    if ($event.inputType.includes("deleteContent")) {
      return;
    }
    const value = $event.target.value.replace(/\D/g, '');
    if (value.length <= 18) {
      $event.target.value = this.mascaraCnpj(value);
    }
  }


  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent & { target: HTMLInputElement }) {
    const pastedText = event.clipboardData?.getData('text/plain');
    if (pastedText) {
      let value = pastedText.replace(/\D/g, '');
      if (value.length <= 18) {
        event.target.value = this.mascaraCnpj(value);
      }
    }
  }

  mascaraCnpj(value: string): string {

    const replacement = this.cnpjType.replace(/\D/g, '').replace(/9/g, '_');
    const valueMask = value + replacement.substring(0, replacement.length - value.length);
    let valueMaskPos = 0;

    value = '';
    for (let i = 0; i < this.cnpjType.length; i++) {
      // tslint:disable-next-line:radix
      if (isNaN(parseInt(this.cnpjType.charAt(i)))) {
        value += this.cnpjType.charAt(i);
      } else {
        value += valueMask[valueMaskPos++];
      }
    }

    if (value.indexOf('_') > -1) {
      value = value.substr(0, value.indexOf('_'));
    }

    return value;

  }

}
